import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=37735d6c&"
import script from "./Spaces.vue?vue&type=script&lang=js&"
export * from "./Spaces.vue?vue&type=script&lang=js&"
import style0 from "./Spaces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports